import dayjs from 'dayjs';

export const isEndingSoon = (endingSoon?: string | null, entryEnd?: string | null): boolean =>
  !!endingSoon && !!entryEnd && dayjs(endingSoon).isBefore(dayjs()) && dayjs(entryEnd).isAfter(dayjs());

export const isEnded = (end?: string | null): boolean => !!end && dayjs(end).isBefore(dayjs());
